import { render, staticRenderFns } from "./kyb.vue?vue&type=template&id=0fb22d78"
import script from "./kyb.vue?vue&type=script&lang=js"
export * from "./kyb.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports